import globals from "./globals";
import $ from "cash-dom";
import Masonry from "masonry-layout";

const layout = (function () {
    /**
     * Initialize Contact Sheet instances
     */
    $(window).on("load", function () {
        if ($(".layout-image-gallery").length) {
            if (globals.debug) console.log("layout-image-gallery initialized");
            var masonryInstances = [];

            $(".layout-image-gallery").each(function () {
                var container = $(this).find(".image-gallery")[0];

                masonryInstances.push(
                    new Masonry(container, {
                        columnWidth: 0,
                        itemSelector: ".image-gallery-image",
                        transitionDuration: 0,
                    })
                );
            });

            $(".image-gallery-image > div").on({
                mouseenter: function () {
                    $(this).find(".button").addClass("on");
                },
                mouseleave: function () {
                    $(this).find(".button").removeClass("on");
                },
            });

            $(window).on("resizeEnd", function () {
                masonryInstances.forEach(function (_el) {
                    // _el.layout();
                });
            });
        }
    });
})();

export default layout;
